export const INIT_DATA = 'INIT_DATA';
export const UPDATE_COURSE_OUTLINE = 'UPDATE_COURSE_OUTLINE';
export const ADD_LESSON_ENTITY = 'ADD_LESSON_ENTITY';
export const ADD_SECTION_HEADING_ENTITY = 'ADD_SECTION_HEADING_ENTITY';
export const UPDATE_LESSONS = 'UPDATE_LESSONS';
export const UPDATE_SECTION_HEADINGS = 'UPDATE_SECTION_HEADINGS';
export const SET_ACTIVE_LESSON = 'SET_ACTIVE_LESSON';
export const ADD_TOPIC_ENTITY = 'ADD_TOPIC_ENTITY';
export const SET_DRAGGABLE_ENTITY = 'SET_DRAGGABLE_ENTITY';
export const SET_IS_DROP_DISABLED_LESSON = 'SET_IS_DROP_DISABLED_LESSON';
export const ADD_QUIZ_ENTITY = 'ADD_QUIZ_ENTITY';
export const UPDATE_QUESTIONS = 'UPDATE_QUESTIONS';
export const ADD_QUESTION_ENTITY = 'ADD_QUESTION_ENTITY';
export const ADD_ANSWER_ENTITY = 'ADD_ANSWER_ENTITY';
export const REMOVE_ANSWER_ENTITY = 'REMOVE_ANSWER_ENTITY';
export const ADD_LESSON = 'ADD_LESSON';
export const ADD_TOPIC = 'ADD_TOPIC';
export const ADD_QUIZ = 'ADD_QUIZ';
export const ADD_QUESTION = 'ADD_QUESTION';
export const UPDATE_WORKSPACE_NODE_TITLE = 'UPDATE_WORKSPACE_NODE_TITLE';
export const UPDATE_NODE_TITLE = 'UPDATE_NODE_TITLE';
export const TOGGLE_EXPAND_ALL = 'TOGGLE_EXPAND_ALL';
export const TOGGLE_EXPAND_ENTITY = 'TOGGLE_EXPAND_ENTITY';
export const ADD_FINAL_QUIZ_ENTITY = 'ADD_FINAL_QUIZ_ENTITY';
export const SORT_FINAL_QUIZZES_OUTLINE = 'SORT_FINAL_QUIZZES_OUTLINE';
export const REMOVE_ENTITY = 'REMOVE_ENTITY';
export const REMOVE_SECTION_HEADING_ENTITY = 'REMOVE_SECTION_HEADING_ENTITY';
export const MOVE_ENTITY = 'MOVE_ENTITY';
export const REMOVE_EXISTING_ENTITY = 'REMOVE_EXISTING_ENTITY';
export const UPDATE_QUESTION_TYPE = 'UPDATE_QUESTION_TYPE';
export const UPDATE_QUESTION_ANSWERS = 'UPDATE_QUESTION_ANSWERS';
